<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import ProductCard from './ProductCard'
//import 'swiper/css/swiper.css'
/**
 * Dashboard Component
 */
export default {
  components: {
    Swiper,
    SwiperSlide,
    ProductCard
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
    	hoverIndex: -1,
    	storageurl: 'https://gemesys-dev.s3.eu-west-2.amazonaws.com/',
    };
  },
  props: {
    user: {
        type: Object,
      },
  	items: {
  		type: Array,
  		default: () => []
  	},
  	swiperOptions: {
				type: Object,
				default: () => {
          // Some Swiper option/callback...
        },
			},
	startSlide: {
		type: Number,
		default: () => 1
	},
	roundedBorders: {
		type: Boolean,
		default: () => true
	},
  },
  computed: {
      swiper() {
        return this.$refs.relatedTradeProductsSwiper.$swiper
      }
    },
   mounted() {
    console.log('Current Swiper instance object', this.swiper);
      this.swiper.slideTo(this.startSlide, 1000, false);
  },
};
</script>

<template>
	<swiper ref="relatedTradeProductsSwiper" :options="swiperOptions">
        <swiper-slide v-for="(product, index) in items">
            <ProductCard :index="index" :product="product.related_product_details" :company="product.related_product_details.company" :user="user"></ProductCard>
        </swiper-slide>
    	<div class="swiper-pagination" slot="pagination"></div>
  	</swiper>
</template>